import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverProps, VideoPopoverDirective } from './../video-popover.directive';

@Component({
  selector: 'rk-popover-trigger',
  standalone: true,
  imports: [VideoPopoverDirective, TranslateModule, MatIconModule],
  templateUrl: './popover-trigger.component.html',
  styleUrl: './popover-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverTriggerComponent {
  @Input() popover: PopoverProps;
}
